export default __webpack_public_path__ + "static/B12-e8788b39a592ddae488de2dc2830b22b.png";